import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import TopBarProgress from "react-topbar-progress-indicator";
import { mainCategories } from "../../../actions/mainCategory";
import { create } from "../../../actions/childCategory";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Alert from "../../../components/alert/alert.component";
import HeadingPrimary from "../../../components/custom-heading/heading-primary";
import HeadingSecondary from "../../../components/custom-heading/heading-secondary";
import CustomInput from "../../../components/custom-input/custom-input";
import ImageUploaderField from "../../../components/img-uploader-field/img-uploader-field";
import MultiValueSelect from "../main-category/components/multi-value-select/multi-value-select";
import CustomTextArea from "../../../components/custom-input/custom-textarea";
import CustomRadioInput from "../../../components/custom-input/custom-radio-input";
import CustomButton, {
  CustomButtonClasses,
  CustomButtonTypes,
} from "../../../components/custom-button/custom-button";
import ChildCategoryInputSelect from "./components/drop-down-select";
import { useDispatch } from "react-redux";
import { createChildCategoryPageValidation } from "../../../components/form-validation-schemas/form-validation-schemas";

const Create = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [formData, setFormData] = useState({
    name: "",
    displayName: "",
    slug: "",
    mainCategoryId: "",
    description: "",
    metaTag: [],
    metaDescription: "",
    metaKeyword: [],
    seoKeyword: [],
    mainCategoriesList: [],
    show: true,
    image: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await dispatch(mainCategories());
        setFormData((prev) => ({
          ...prev,
          mainCategoriesList: res?.mainCategories,
        }));
      } catch (error) {
        console.log("error is : ", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const resetForm = () => {
    setFormData({
      name: "",
      displayName: "",
      slug: "",
      mainCategoryId: formData?.mainCategoryId,
      description: "",
      metaTag: [...formData?.metaTag],
      metaDescription: "",
      metaKeyword: [...formData?.metaKeyword],
      seoKeyword: [...formData?.seoKeyword],
      mainCategoriesList: [...formData?.mainCategoriesList],
      show: true,
      image: formData?.image,
    });
  };

  const handleSubmit = async () => {
    const { mainCategoriesList, ...dataTosend } = formData;

    setLoading(true);
    try {
      await createChildCategoryPageValidation.validate(formData);
      const res = await dispatch(create(dataTosend));
      if (res) {
        resetForm();
        setError("");
        toast(`${res.data}`, { containerId: "B" });
      }
    } catch (error) {
      if (error?.name === "ValidationError") {
        setError(error.errors[0]);
        toast.error(`${error.errors[0]}`, { containerId: "B" });
      }
    } finally {
      setLoading(false);
    }
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handleImageChange = async (e, key) => {
    const base64Image = await toBase64(e[0]);
    setFormData((prev) => ({ ...prev, [key]: base64Image }));
  };

  const changeInputTags = (value, key) => {
    const data = value?.map((item) => item.value) || [];
    setFormData((prev) => ({
      ...prev,
      [key]: data,
    }));
  };

  const handleChange = (e) => {
    e.persist();
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const getOptions =
    Array.isArray(formData?.mainCategoriesList) &&
    formData?.mainCategoriesList?.map((item) => ({
      value: item?._id,
      label: item?.name,
    }));

  return (
    <div className="container-scroller">
      {loading && <TopBarProgress />}
      <ToastContainer
      stacked 
        enableMultiContainer
        containerId={"B"}
        // position={toast.POSITION.TOP_RIGHT}
          position="top-right" // Hardcoded position
      />

      <div className="page-header">
        <HeadingPrimary>Create Child Category</HeadingPrimary>
        <div style={{ fontSize: ".9rem" }}>
          <Link to="/admin/child-categories">Child Categories </Link>
          /&nbsp;Create Child Category
        </div>
      </div>

      <span className="text-danger">{error}</span>
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="card p-0" style={{ border: "1px solid #dcdcdc" }}>
            <div className="card-body p-0">
              <HeadingSecondary>Add a new child category</HeadingSecondary>
              <Alert />

              <form className="forms-sample m-3">
                <CustomInput
                  label="Name"
                  name="name"
                  type="text"
                  placeholder="Name"
                  labelStyles={{ fontWeight: "bold" }}
                  onChange={handleChange}
                  value={formData?.name}
                />

                <CustomInput
                  label="Display Name"
                  name="displayName"
                  type="text"
                  placeholder="Name"
                  labelStyles={{ fontWeight: "bold" }}
                  onChange={handleChange}
                  value={formData.displayName}
                />

                <CustomInput
                  label="Slug"
                  name="slug"
                  type="text"
                  placeholder="Slug"
                  labelStyles={{ fontWeight: "bold" }}
                  onChange={handleChange}
                  value={formData.slug}
                />

                <ImageUploaderField
                  labelStyles={{ fontWeight: "bold" }}
                  label="Image upload"
                  buttonText="Choose image"
                  name="image"
                  onChange={(e) => handleImageChange(e, "image")}
                />

                <ChildCategoryInputSelect
                  name="mainCategoryId"
                  label="Select parent category"
                  onChange={handleChange}
                  options={getOptions}
                />

                <MultiValueSelect
                  label="Meta Tags"
                  defaultValue={formData?.metaTag}
                  name="metaTags"
                  labelStyles={{ fontWeight: "bold" }}
                  onChange={(value) => changeInputTags(value, "metaTag")}
                />

                <MultiValueSelect
                  label="Meta Keywords"
                  defaultValue={formData.metaKeyword}
                  name="metaKeyword"
                  labelStyles={{ fontWeight: "bold" }}
                  onChange={(value) => changeInputTags(value, "metaKeyword")}
                />

                <CustomTextArea
                  label="Meta Description"
                  labelStyles={{ fontWeight: "bold" }}
                  name="metaDescription"
                  rows={6}
                  value={formData.metaDescription}
                  onChange={handleChange}
                />

                <MultiValueSelect
                  label="Seo Keywords"
                  defaultValue={formData.seoKeyword}
                  name="seoKeyword"
                  onChange={(value) => changeInputTags(value, "seoKeyword")}
                />

                <CustomTextArea
                  label="Description"
                  labelStyles={{ fontWeight: "bold" }}
                  name="description"
                  rows={6}
                  value={formData.description}
                  onChange={handleChange}
                />

                <div className="form-group ">
                  <label
                    style={{ fontWeight: "bold" }}
                    className="col-sm-3 col-form-label"
                  >
                    Show in Header
                  </label>
                  <div className="col-sm-12">
                    <CustomRadioInput
                      label="Yes"
                      required={true}
                      type="radio"
                      id="radio1"
                      name="membershipRadios"
                      checked={formData?.show === true}
                      labelStyles={{ fontWeight: "bold" }}
                      value={formData.show}
                      onChange={() => setFormData({ ...formData, show: true })}
                    />
                  </div>

                  <div className="col-sm-5">
                    <CustomRadioInput
                      label="No"
                      required={true}
                      type="radio"
                      name="membershipRadios"
                      id="radio2"
                      checked={formData?.show === false}
                      labelStyles={{ fontWeight: "bold" }}
                      value={formData.show}
                      onChange={() => setFormData({ ...formData, show: false })}
                    />
                  </div>
                </div>
                <CustomButton
                  type={CustomButtonTypes.BUTTON}
                  className={CustomButtonClasses.PRIMARY}
                  onClick={handleSubmit}
                >
                  Submit
                </CustomButton>
                <Link to={"/admin/child-categories"}>
                  <CustomButton
                    className={CustomButtonClasses.LIGHT}
                    type={CustomButtonTypes.BUTTON}
                  >
                    Cancal
                  </CustomButton>
                </Link>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Create;
